export default "__VITE_ASSET__DwJbY0f$__"